import { ConfirmationModal } from "@/view/components/ConfirmationModal";
import { Button } from "@/view/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogTrigger,
} from "@/view/components/ui/dialog";
import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { useToast } from "@/view/components/ui/use-toast";
import { approveTransaction } from "@/app/services/transactionService/approve";

interface ModalApproveTransactionProps {
  transactionId: string;
}

export const ModalApproveTransaction = ({
  transactionId,
}: ModalApproveTransactionProps) => {
  const queryClient = useQueryClient();

  const modalCloseRef = useRef<HTMLButtonElement>(null);

  const { toast } = useToast();

  const handleSubmit = async () => {
    try {
      await approveTransaction(transactionId);

      const cachedData = queryClient.getQueryData<any>([
        "transactions",
        "transactionById",
        transactionId,
      ]);

      queryClient.setQueriesData(
        { queryKey: ["transactions", "transactionById", transactionId] },
        { ...cachedData, status: "PENDING" },
      );

      toast({ title: "Transação aprovada com sucesso" });
    } catch (error: any) {
      toast({
        title: "Não foi possível aprovar essa transação",
        variant: "destructive",
      });
    } finally {
      modalCloseRef.current?.click();
    }
  };

  return (
    <Dialog>
      <DialogClose ref={modalCloseRef} />

      <DialogTrigger className="w-full">
        <Button className="mt-4 w-full text-white">Aprovar transação</Button>
      </DialogTrigger>

      <ConfirmationModal
        title="Aprovar Proposta"
        onConfirm={handleSubmit}
        Content={
          <>
            Deseja mesmo <b>aprovar</b> essa transação?
          </>
        }
      />
    </Dialog>
  );
};
